import Link from 'next/link';
import { useRouter } from 'next/router';
import styled from 'styled-components';
import { formatMinutesToRead } from 'utils/helpers';
import i18n, { SettingsType } from 'utils/i18n';

export type UnitItemProps = {
  unit: Unit;
  checked?: boolean;
};

export const UnitItem: React.FC<UnitItemProps> = ({ unit, checked = false }) => {
  const { locale } = useRouter();
  const { dictionary } = i18n[(locale as AcceptedLocales) || 'en-US'] as SettingsType;

  return (
    <StyledUnitItem className="unit">
      <div className="info">
        <Link href={unit.meta?.path || ''}>{unit.title}</Link>
        {unit.meta?.readingTime && (
          <div className="minutes">{formatMinutesToRead(unit.meta?.readingTime, dictionary)}</div>
        )}
      </div>
      {checked && (
        <div>
          <span className="checkmark-completed docon docon-check"></span>
        </div>
      )}
    </StyledUnitItem>
  );
};

export const StyledUnitItem = styled.div`
  border-left: 4px solid var(--border);
  padding-left: 0.75rem;
  display: flex;
  justify-content: space-between;
  align-items: center;

  &:hover {
    border-left: 4px solid var(--primary-base);
  }

  .info {
    flex: 1 1 0;
  }
  .minutes {
    margin-top: 0.5rem;
    color: var(--text-subtle);
    font-size: 0.75rem;
  }

  .checkmark-completed {
    color: var(--success-base) !important;
  }
`;

export default UnitItem;
